<template>
    <div class="productOfListBriefMain">
        <div
            class="
                productImgWrapper
            "
        >
            <img
                loading="lazy"
                style="
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0px;
                    left: 0px;
                "
                :src="getImgUrl(productImg)"
            />

            <van-tag
                v-show="priceType"
                color="#7232dd"
                style="position: absolute; top: 0px; right: 0px;"
                >{{ getPriceTypeName(priceType) }}</van-tag
            >

            <ProductLeftBottomTag v-if="distance != null" :distance="distance" :transportationDescriptionList="transportationDescriptionList"/>
        </div>
        <div class="productTextDescriptionWrapper">
            <div
                class="
                    productName
                "
            >
                {{ productName }}
            </div>
            <div style="display:flex;align-items:center;">
                <div class="priceWrapper">
                    <span class="nowPrice">
                        ￥{{ lodash.round(productPrice, 1) }}
                        <template v-if="productOriginalPrice == -1">起</template>
                    </span>
                    <span class="originalPrice" v-if="productOriginalPrice != 0 && productOriginalPrice != -1">￥{{ lodash.round(productOriginalPrice, 1) }}</span>
                </div>

                <div ref="addToCartView" class="addToCartView" @click.stop="">
                    <van-badge v-if="specificationList.length > 1" :content="purchasedNumber" class="selectSpecificationButton">
                        <button
                            @click="showSpecification"
                            >选择规格</button>
                    </van-badge>
                    <ProductIncAndDesc v-model="purchasedNumber" :maxBuyNum="checkMaxBuyNum(shopId, productId, specificationList[0].id)" :maxNumber="specificationList[0].stock" @dataChange="updateCart" v-else />
                </div>
            </div>
        </div>

        <BaseParabolaAnimate ref="addToCartAnimate" :imgPic="getImgUrl(productImg)"/>
    </div>
</template>

<script>
//
import { mapState, mapGetters, } from 'vuex'

//
import ProductSpecification from '@/components/common/ProductSpecification.vue'

//
import { returnFloatWith2DecimalFraction } from '#/utils/number'

//
import ProductLeftBottomTag from "#/common_components/tag/ProductLeftBottomTag.vue";
//
import ProductIncAndDesc from '@/components/shop/ProductIncAndDesc.vue'

export default {
    name: 'ProductOfListBrief',

    components: {
        ProductLeftBottomTag,
        ProductIncAndDesc,
    },
    
    props: {
        shopId: {
            type: Number,
            required: true,
        },

        productId: {
            type: Number,
            required: true,
        },

        distance: {
            type: Number || null,
        },

        transportationMode: {
            type: Number || null,
        },

        transportationDescriptionList: {
            type: Array,
        },

        priceType: {
            
        },

        productName: {
            type: String,
            required: true,
        },

        productImg: {
            type: String,
            required: true,
        },

        productOriginalPrice: {
            type: Number,
            required: true,
        },

        productPrice: {
            type: Number,
            required: true,
        },

        specificationList: {
            type: Array,
            default: () => {
                return [
                    {
                        id: '',
                        pictures: '', //
                        productId: '',
                        specificationMsg: '',
                        specificationName: '', //
                        specificationPrice: '', //
                        stock: 0,
                    },
                ]
            },
        },

        shelfId: {
            default: () => {
                return [];
            },
        },
    },

    computed: {
        ...mapState({
            cartInfoAll: (state) => state.cart.cartInfoAll,
        }),

        ...mapGetters('cart', [
            'getCartInfo',
        ]),
    },

    data() {
        return {
            purchasedNumber: 0,
        }
    },

    created() {
        //
        this.checkPurchaseNumber()
    },

    watch: {
        cartInfoAll() {
            this.checkPurchaseNumber()
        },
    },

    methods: {
        returnFloatWith2DecimalFraction,

        checkPurchaseNumber() {
            //
            const cartInfo = this.getCartInfo(this.shopId);

            /**
             * 
             */
            this.purchasedNumber = 0;

            // console.log(
            //     `ProductOfShop, checkPurchaseNumber, this.productId: ${this.productId}`
            // )

            //
            for (let item of cartInfo.shoppingCars) {
                //
                if (item.productInfo.pId == this.productId) {
                    this.purchasedNumber += item.snum;
                }
            }
        },

        showSpecification() {
            this.createComponent(ProductSpecification, {
                props: {
                    specificationList: this.specificationList,
                    productName: this.productName,
                    productId: this.productId,
                    shopId: this.shopId,
                    productImg: this.productImg,
                    shelfId: this.shelfId,
                }
            })
        },

        updateCart(value)
        {
            //
            if(value > 0)
            {
                this.$refs.addToCartAnimate.addToCartAnimate(this.$refs.addToCartView, document.getElementById("componentCartIcon"));
            }

            //
            this.cartApiAddToCart(
                this.shopId,
                this.specificationList[0].id,
                value,
                this.productId,
                '',
            );
        },
    },
}
</script>

<style lang="scss" scoped>

.productOfListBriefMain
{
    font-size: $fontSizeContent;
    line-height: 2em;
}

.productImgWrapper
{
    width: 100%;
    position: relative;
    height: 0;
    padding-top: 100%;
    border-radius: $borderRadius $borderRadius 0px 0px;
    overflow: hidden;
}

//
.productTextDescriptionWrapper
{
    box-sizing: border-box;
    padding: 0.08rem;
}

.productName
{
    font-weight: 500;
    overflow: auto;
    white-space: nowrap;
}

.priceWrapper
{
    display: flex;
    align-items: center;
    overflow: auto;
    white-space: nowrap;
    font-weight: 500;
    flex-grow: 1;
    margin-right: 0.08rem;

    .nowPrice
    {
        color: #ff4824;
    }

    .originalPrice
    {
        color: $neutralFontWeakColor;
        text-decoration: line-through;
    }
}

//
.addToCartView
{
    flex-shrink: 0;
    display:flex;
    justify-content:flex-end;
}

.selectSpecificationButton
{
    margin-right: 0.5em;
}


</style>